import React, { Fragment, useEffect } from 'react';
import { Button, Col, Form, message, Row } from 'antd';
import SupplierInformation from './components/SupplierInformation';
import AddressInformation from './components/AddressInformation';
import { useHistory, useParams } from 'react-router-dom';
import * as CommonService from '../../../services/CommonService';
import AdditionalInformation from './components/AdditionalInformation';
import { SUPPLIER } from '../../../services/endpoint';

const SupplierEdit = (props) => {

	const history = useHistory();

	const [supplier, setSupplier] = React.useState({});

	const { id } = useParams();

	useEffect(() => {
		window.setLoading(true);
		CommonService.findById(SUPPLIER, id).then(res => {
			if (res?.status === 200) {
				setSupplier(res.data || {});
				props.form.setFieldsValue({
					...res.data
				});
			}
		}).catch(err => {
			message.error(err?.data?.message || 'Có lỗi xảy ra');
		}).finally(() => window.setLoading(false));
	}, []);

	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				window.setLoading(true);
				const body = {
					...values
				}
				delete body.totalDebt
				CommonService.update(SUPPLIER, id, body).then(res => {
					if (res.status === 200) {
						message.success('Cập nhật nhà cung cấp thành công');
						history.push('/supplier');
					}
				}).catch(err => message.error(err?.data?.message || 'Có lỗi xảy ra'))
					.finally(() => window.setLoading(false));
			}
		});
	};

	return (
		<Fragment>
			<Form layout={'vertical'}>
				<Row gutter={12}>
					<Col span={24}>
						<Row gutter={12}>
							<Col className={'mb-10'}>
								<SupplierInformation form={props.form} />
							</Col>
							<Col className={'mb-10'}>
								<AddressInformation form={props.form} />
							</Col>
						</Row>
					</Col>
					<Col span={24}>
						<AdditionalInformation form={props.form} />
					</Col>
				</Row>
				<Col style={{ textAlign: 'right', marginTop: 10 }}>
					<Button style={{ marginRight: '5px' }} onClick={() => history.push('/supplier')}>Thoát</Button>
					<Button type={'primary'} onClick={handleSubmit}>Cập nhật nhà cung cấp</Button>
				</Col>
			</Form>
		</Fragment>
	);
};
export default Form.create({ name: 'SupplierEdit' })(SupplierEdit);

